<section class="content-slider container-fluid ctf-slider">
    <swiper class="swiper-container" fxFlex="auto" [config]="config" [disabled]="disabled">
        <figure class="item swiper-slide" *ngFor="let slider of sliders ; let i = index" [ngClass]="{'cursor-pointer': slider.fields['action']}">
            <img [src]="slider.fields.image" *ngIf="slider.fields['action']" (click)="openWindow(slider)"/>
            <img [src]="slider.fields.image" *ngIf="!slider.fields['action']" />
            <div id="counter" class="slider-counter">{{i+1}}</div>
        </figure>
    </swiper>
</section>
